export enum GameReportType {
  RoundGame = 'round_game',
  BetGame = 'bet_game',
}
